<template>

    <div class="containter-fluid bg-primary text-center py-4 text-white">

        <div class="container">
        
        <div class="py-5">
        <p v-if="$page.props.global_config.contactus.address"><font-awesome-icon icon="map-marker-alt" /> {{$page.props.global_config.contactus.address}}</p>
        <p v-if="$page.props.global_config.contactus.tel"><font-awesome-icon icon="phone" /> {{$page.props.global_config.contactus.tel}}</p>
        <p v-if="$page.props.global_config.contactus.email"><font-awesome-icon icon="envelope" /> {{$page.props.global_config.contactus.email}}</p>
        </div>
        <hr style="border-color:rgba(255,255,255,0.3);"/>
        <small style="color:rgba(255,255,255,0.4);">Copyright © 2021 {{$page.props.global_config.general.website_name}}. All Rights Reserved.</small>
        </div>

    </div>

</template>

<script>

</script>